import CountCard from "../../../components/CounterCard";
interface BookingDetail {
    count: string;
    label: string;
    backgroundColor: string;
    textColor: string;
  }
  
  const inBookingDetails: BookingDetail[] = [
    {
      count: "25",
      label: "Total Trip",
      backgroundColor: "#6991FF",
      textColor: "white",
    },
    {
      count: "08",
      label: "Unassigned ",
      backgroundColor: "#FF9788",
      textColor: "white",
    },
    {
      count: "05",
      label: "Ongoing",
      backgroundColor: "#73DC9D",
      textColor: "white",
    },
    {
      count: "12",
      label: "Cancelled",
      backgroundColor: "#FFB470",
      textColor: "white",
    },
    {
      count: "05",
      label: "Completed",
      backgroundColor: "#73DC9D",
      textColor: "white",
    },
  ];
  
  const BookingDetails: React.FC = () => {
    return (
      <div className="flex justify-around !w-full p-4">
        {inBookingDetails.map((status, index) => (
          <CountCard
            key={index}
            count={status.count}
            label={status.label}
            backgroundColor={status.backgroundColor}
            textColor={status.textColor}
            className="w-[16%] gap-3 !text-[14px]"
            classNameCount="!text-[14px]"
            // classNameLabel="w-[16%] gap-3 !text-[14px]"
          />
        ))}
      </div>
    );
  };
  
  export default BookingDetails;
  